<script>
	// NPM Modules
	import { tick } from 'svelte';
	// Partials
	import ListSportEvents from '@/Partials/Sport/Manage/Events/_List.svelte';
	import CreateSportEvent from '@/Partials/Sport/Manage/Events/_Create.svelte';

	export let sport;

	let sportEventList;
	let showCreateSportEvent = false;

	async function openCreateSportEvent() {
		showCreateSportEvent = true;
		await tick();
		window.scrollTo(0, 0);
	}
</script>

{#if showCreateSportEvent}
	<CreateSportEvent bind:open={showCreateSportEvent} bind:sport on:created={sportEventList.refreshSportEvents} />
{/if}

<div>
	<div class="flex items-end justify-end w-full">
		<button on:click={() => openCreateSportEvent()} class="btn btn-primary"> Create event </button>
	</div>
	<ListSportEvents bind:sport bind:this={sportEventList} />
</div>
